import { Button, useDisclosure } from '@chakra-ui/react'
import NotesList from 'components/MainApp/Notes/NotesList'
import Avatar from 'components/MainApp/Profile/Avatar'
import { format } from 'date-fns'
import { useNotes } from 'hooks/notes'
import { useUser } from 'hooks/users'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import 'stylesheets/MainAppStyles/UserProfile.css'
import EditProfile from './EditProfile'
import { useAuth } from 'hooks/auth'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/free-regular-svg-icons'
import { faHeart } from '@fortawesome/free-solid-svg-icons'
import { faBook } from '@fortawesome/free-solid-svg-icons'
import { Icon } from '@iconify/react'

const UserProfile = () => {
    const [likes, setLikes] = useState(0);
    const { id } = useParams()
    const { notes, isLoading: notesLoading } = useNotes(id)

    const { user, isLoading: userLoading } = useUser(id)
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { user: authUser, isLoading: authLoading } = useAuth()

    useEffect(() => {
        if (!notesLoading) {
            let numLikes = 0
            notes.map(note => {
                numLikes = numLikes + note.likes.length
            })
            setLikes(numLikes)
        }
    }, [notes]);

    if (authLoading || userLoading) return "Loading..."
    return (
            <div className="user-profile-container">
                <div className="banner-edit">
                    <img className="banner" src="https://images.pexels.com/photos/998641/pexels-photo-998641.jpeg?cs=srgb&dl=pexels-francesco-ungaro-998641.jpg&fm=jpg" alt="" />
                </div>
                <div className="user-main-info">
                    <div className="avatar-edit">
                        <Avatar user={user} />
                        {
                            !authLoading && authUser.id === id && (
                                <Button className='change-avatar-button' onClick={onOpen}><Icon className='icon' icon='material-symbols:edit'/></Button>
                            )
                        }
                    </div>
                    <div className="text-user-header">
                        <div className="section-1">
                            <p className='username'>{user.username}</p>
                        </div>
                        <div className="section-2">
                            <h2>{user.name} {user.lastname}</h2>
                            <p className='joined'><FontAwesomeIcon icon={faCalendar} /> Joined: {format(user.date, "MMMM YYY")}</p>
                        </div>
                    </div>
                </div>
                <div className="user-content">
                    <div className="about-user">
                        <h3>Sobre mí</h3>
                        <p>Hola, Soy {user.name}! Actualmente el equipo de TreePilot está desarrollando la personalización de esta sección </p>
                    </div>
                    <div className="profile-cards-container">
                        <div className='user-profile-card'>
                            <div className="user-profile-card-content">
                                <Icon icon="solar:notes-bold-duotone" className="icon"/>
                                <p className='number'>{notes.length}</p>
                                <p className='text-type'>Notas</p>
                            </div>
                        </div>
                        <div className='user-profile-card'>
                            <div className="user-profile-card-content">
                                <Icon icon="tabler:heart" className='icon'/>
                                <p className='number'>{likes}</p>
                                <p className='text-type'>Likes</p>
                            </div>
                        </div>
                    </div>
                    <EditProfile isOpen={isOpen} onClose={onClose} />
                    <div className='user-profile-posts'>
                        {notesLoading ? <p>Notes Loading...</p> : (
                            <NotesList notes={notes} />
                        )}
                    </div>
                </div>
            </div>
    )
}

export default UserProfile